import {Component, EventEmitter, OnDestroy, AfterViewInit, Output, ChangeDetectorRef} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {KeyDateService} from 'app/service/key-date.service';
import {
  EditorBaseComponent, GenericValue,
  KeyLabelEntry, LogManager, ModelChangeService,
  ModelTransformerService,
  PersistenceService, SettingsService, UiUpdateService,
  ValidationChangeService,
} from '@visana-web/basic-ui';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ClientModel} from 'app/model/client-model';


@Component({
  selector: 'app-search-criteria',
  templateUrl: './search-criteria.component.html',
  styleUrls: ['./search-criteria.component.scss'],
})
export class SearchCriteriaComponent extends EditorBaseComponent implements AfterViewInit, OnDestroy {


  perimeterValues: KeyLabelEntry[] = [{
    key: '0',
    labelValue: 'imprest.perimeter.0',
    needsReloadAfterLanguageChange: false,
  },
    {key: '5', labelValue: 'imprest.perimeter.5', needsReloadAfterLanguageChange: false},
    {key: '10', labelValue: 'imprest.perimeter.10', needsReloadAfterLanguageChange: false}];

  keyDatesObservable: Observable<KeyLabelEntry[]>;
  baseInsuranceModelUrl = '/webresources/imprestAccount/r4/medicalNetworks';
  insuranceModelUrl = '/webresources/imprestAccount/r4/medicalNetworks';
  baseMedicalNetworkUrl = '/webresources/imprestAccount/r4/medicalNetworks/medicalNetwork';
  postCodes = '';

  zsrNr = '';
  _typeAheadName: KeyLabelEntry[] = [];

  subscription: Subscription;
  languageSubscription: Subscription;
  _zipLocation: KeyLabelEntry[] = [];
  _currentKeyDate: KeyLabelEntry[] = [];

  @Output()
  resetEvent = new EventEmitter();

  @Output()
  searchCriteria = new EventEmitter<GenericValue>();

  private clientModel: ClientModel = new ClientModel();


  constructor(
              private keyDateService: KeyDateService,
              protected modelTransformerService: ModelTransformerService,
              protected persistenceService: PersistenceService,
              protected validationChangeService: ValidationChangeService,
              protected uiUpdateService: UiUpdateService,
              protected modalService: NgbModal,
              protected changeDetectorRef: ChangeDetectorRef,
              protected settingsService: SettingsService,
              private modelChangeService: ModelChangeService<ClientModel>,
              protected translateService: TranslateService,
              protected logManager: LogManager,
  ) {
    super(
      modelTransformerService,
      persistenceService,
      validationChangeService,
      uiUpdateService,
      modalService,
      changeDetectorRef,
      logManager,
    );
    this.validationGroup = 'searchValidation';
    this.updateScope = 'searchUpdate';
    this.buttonLabelKeyDelete = 'imprest.cancel';
    this.buttonLabelKeyAbort = 'imprest.cancel';
    this.componentId = 'imprest.main.page';
    this.keyDatesObservable = this.keyDateService.getKeyDates();
  }

  get keyDateModel(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'keyDate');
  }

  /**
   * Gibt den Endpoint an, wo sich der Client ein leeres Template-Modell holen kann.
   */
  protected getTemplateEndPoint(): string {
    return '/webresources/imprestAccount/r4/gatekeepers/template';
  }

  /**
   * An diesen Endpoint schickt der Client sein Modell zum update.
   */
  protected getUpdateEndPoint(): string {
    return '/webresources/imprestAccount/r4/gatekeepers/update';
  }

  /**
   * Wird ausgeführt, nachdem die Daten an den Server geschickt wurden. Ist die Source im ClientModel auf 'ch.visana.app' gestellt,
   * wird die nächste Seite mit Url Parametern aufgerufen (Visana App Integration)
   */
  protected selectedValueLoaded(): boolean {
    if (!super.selectedValueLoaded()) {
      this.clientModel.searchResult = this.selectedValue;
      this.modelChangeService.updateModel(this.clientModel);
      return false;
    }
    return true;
  }


  public updateObject() {
    if (this.isSaveButtonDisabled()) {
      return;
    }
    this.clientModel.searchResult = null;
    this.clientModel.searchCriteria = this.selectedValue;
    this.modelChangeService.updateModel(this.clientModel);
    this.persistenceService.getGenericValue(this.getTemplateEndPoint()).subscribe(en => {
      this.modelTransformerService.setModelValue(en, 'uniqueId', this.modelTransformerService.getModelValue(this.selectedValue, 'uniqueId'));
      this.modelTransformerService.setModelValue(en, 'keyDate', this.keyDate[0].key);
      this.modelTransformerService.setModelValue(en, 'zsrNr', this.modelTransformerService.getModelValue(this.selectedValue, 'zsrNr'));
      this.modelTransformerService.setModelValue(en, 'name', this.modelTransformerService.getModelValue(this.selectedValue, 'name'));
      this.modelTransformerService.setModelValue(en, 'givenName', this.modelTransformerService.getModelValue(this.selectedValue, 'givenName'));
      this.modelTransformerService.setModelValue(en, 'zipLocation', this.modelTransformerService.getModelValue(this.selectedValue, 'zipLocation'));
      this.modelTransformerService.setModelValue(en, 'insuranceModelType', this.modelTransformerService.getModelValue(this.selectedValue, 'insuranceModelType'));
      this.modelTransformerService.setModelValue(en, 'perimeter', this.modelTransformerService.getModelValue(this.selectedValue, 'perimeter'));
      this.modelTransformerService.setModelValue(en, 'billerType', this.modelTransformerService.getModelValue(this.selectedValue, 'billerType'));
      this.modelTransformerService.setModelValue(en, 'medicalNetwork', this.modelTransformerService.getModelValue(this.selectedValue, 'medicalNetwork'));
      this.selectedValue = en;
      super.updateObject();
    });
  }

  /**
   * Eventhandler für den Abbrechen Button. Alle bereits eingegebenen Daten werden verworfen und es wird auf die Einstiegsseite navigiert.
   */
  public deleteObject() {
    this.logManager.info('deleteObject called');
    super.deleteObject();
    this._zipLocation = [];
    this.typeAheadName = [];
    this.ngAfterViewInit();
  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  public ngAfterViewInit() {
    this.addObject();
    this.languageSubscription = this.translateService.onLangChange.subscribe(val => {
      if (this.selectedValue) {
        this.deleteObject();
      }
    });
    this.keyDatesObservable = this.keyDateService.getKeyDates();
    if (!this.subscription) {
      this.subscription = this.settingsService.getUrlParamEventObserver().subscribe(value => {
        if (!value || !value.value || !value.key) {
          return;
        }
        if ((value.key.toLowerCase() === 'reset') && (value.value.toLowerCase() === 'true')) {
          this.deleteObject();
        }
      });
    }
  }


  public handleNameTypeaheadChange(event: KeyLabelEntry[]) {
    this.logManager.debug('handleNameTypeaheadChange: event', event);
    if (!event || (event.length < 1)) {
      this.zsrNr = undefined;
      this.name = undefined;
    } else {
      const key = event.map(val => val.children ? val.children.map(value2 => value2.key) : val.key).toString();
      if (key == 'customValueKey') {
        this.zsrNr = undefined;
      } else {
        this.zsrNr = key;
        this.name = undefined;
      }
    }
  }

  get typeAheadName(): KeyLabelEntry[] {
    return this._typeAheadName;
  }

  set typeAheadName(value: KeyLabelEntry[]) {
    this.logManager.debug('typeAheadName: value', value);
    if (JSON.stringify(this._typeAheadName) != JSON.stringify(value)) {
      if (value && value.length > 0) {
        if (value[0].key == 'customValueKey') {
          this.modelTransformerService.setModelValue(this.selectedValue, 'name', value[0].labelValue);
          this.modelTransformerService.setModelValue(this.selectedValue, 'zsrNr', undefined);
        } else {
          this.modelTransformerService.setModelValue(this.selectedValue, 'name', undefined);
          this.modelTransformerService.setModelValue(this.selectedValue, 'zsrNr', value[0].key);
          this.updateObject();
        }
      } else {
        this.modelTransformerService.setModelValue(this.selectedValue, 'zsrNr', undefined);
      }
      this._typeAheadName = value;
    }
  }


  public handleZipLocationChange(event: KeyLabelEntry[]) {
    this.logManager.debug('handleZipLocationChange: event', event);
    if (!event || (event.length < 1)) {
      if (this.modelTransformerService.getModelValue(this.selectedValue, 'keyDate')) {
        this.insuranceModelUrl = this.baseInsuranceModelUrl+ '?keyDate=' + this.modelTransformerService.getModelValue(this.selectedValue, 'keyDate');
      } else {
        this.insuranceModelUrl = this.baseInsuranceModelUrl;
      }
      this.postCodes = '';
      return;
    }
    this.insuranceModelUrl = this.baseInsuranceModelUrl + '?postCodes=' + this.getCommaSeparatedZipCodes(event);
    this.postCodes = this.getCommaSeparatedZipCodes(event);
    if (this.postCodes.length > 0) {
      this.postCodes = '?postCodes=' + this.postCodes;
    }
    if (this.insuranceModelUrl.indexOf('?') > -1) {
      this.insuranceModelUrl = this.insuranceModelUrl + '&keyDate=' + this.modelTransformerService.getModelValue(this.selectedValue, 'keyDate');
    } else {
      this.insuranceModelUrl = this.insuranceModelUrl + '?keyDate=' + this.modelTransformerService.getModelValue(this.selectedValue, 'keyDate');
    }
  }

  private getCommaSeparatedZipCodes(value: KeyLabelEntry[]) {
    const ret = value.map(val => val.children ? val.children.map(value2 => value2.key) : val.key).toString();
    this.logManager.debug('getCommaSeparatedZipCodes: postCodes', ret);
    return ret;
  }

  get keyDateAsParam(): string {
    if (this.keyDate.length > 0) {
      return '?keyDate=' + this.keyDate[0].key;
    }
    return '';
  }

  get medicalNetworkUrl(): string {
    let imt = this.insuranceModelType;
    if (!imt || (imt.length < 1)) {
      imt = 'ALL';
    }
    const keyDateParam = (this.postCodes.indexOf('?') > -1) ? '&keyDate=' : '?keyDate=';
    const keyDate = (this.keyDate.length > 0) ? keyDateParam + this.keyDate[0].key : '';
    return this.baseMedicalNetworkUrl + '/' + imt + this.postCodes + keyDate;
  }

  get searchState(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'searchState');
  }

  get name(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'name');
  }

  set name(value: string) {
    if (this.modelTransformerService.getModelValue(this.selectedValue, 'name') === value) {
      return;
    }
    this.modelTransformerService.setModelValue(this.selectedValue, 'name', value);
  }

  get givenName(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'givenName');
  }

  set givenName(value: string) {
    if (this.modelTransformerService.getModelValue(this.selectedValue, 'givenName') === value) {
      return;
    }
    this.modelTransformerService.setModelValue(this.selectedValue, 'givenName', value);
  }

  get insuranceModelType(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'insuranceModelType');
  }

  set insuranceModelType(value: string) {
    if (this.modelTransformerService.getModelValue(this.selectedValue, 'insuranceModelType') === value) {
      return;
    }
    this.modelTransformerService.setModelValue(this.selectedValue, 'insuranceModelType', value);
  }

  get medicalNetwork(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'medicalNetwork');
  }

  set medicalNetwork(value: string) {
    if (this.modelTransformerService.getModelValue(this.selectedValue, 'medicalNetwork') === value) {
      return;
    }
    this.modelTransformerService.setModelValue(this.selectedValue, 'medicalNetwork', value);
  }

  get billerType(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'billerType');
  }

  set billerType(value: string) {
    if (this.modelTransformerService.getModelValue(this.selectedValue, 'billerType') === value) {
      return;
    }
    this.modelTransformerService.setModelValue(this.selectedValue, 'billerType', value);
  }

  get keyDate(): KeyLabelEntry[] {
    return this._currentKeyDate;
  }

  set keyDate(value: KeyLabelEntry[]) {
    if (this._currentKeyDate != value) {
      if (value && value.length > 0) {
        this.modelTransformerService.setModelValue(this.selectedValue, 'keyDate', value[0].key);
      } else {
        this.modelTransformerService.setModelValue(this.selectedValue, 'keyDate', undefined);
      }
      this.handleKeyDateChange(this.modelTransformerService.getModelValue(this.selectedValue, 'keyDate'));
    }
    this._currentKeyDate = value;
  }

  private handleKeyDateChange(keyDate: string) {
    if (!keyDate) {
      return;
    }
    this.handleZipLocationChange(this.zipLocation);
    if (this.insuranceModelUrl.indexOf('?') > -1) {
      this.insuranceModelUrl = this.insuranceModelUrl + '&keyDate=' + keyDate;
    } else {
      this.insuranceModelUrl = this.insuranceModelUrl + '?keyDate=' + keyDate;
    }
  }

  get zipLocation(): KeyLabelEntry[] {
    return this._zipLocation;
  }

  set zipLocation(value: KeyLabelEntry[]) {
    const shortValue = this.getCommaSeparatedZipCodes(value);
    this.logManager.info('LongShort value shortvalue modelvalue', value, shortValue, this.modelTransformerService.getModelValue(this.selectedValue, 'zipLocation'));
    if (this.modelTransformerService.getModelValue(this.selectedValue, 'zipLocation') === shortValue) {
      return;
    }
    this.modelTransformerService.setModelValue(this.selectedValue, 'zipLocation', shortValue);
    this._zipLocation = value;
  }

  get perimeter(): string {
    return this.modelTransformerService.getModelValue(this.selectedValue, 'perimeter');
  }

  set perimeter(value: string) {
    if (this.modelTransformerService.getModelValue(this.selectedValue, 'perimeter') === value) {
      return;
    }
    this.modelTransformerService.setModelValue(this.selectedValue, 'perimeter', value);
  }

}
